import React from "react";
import { Feather, PenTool, Heart } from "lucide-react";

export default function FounderSection() {
  return (
    <section
      id="founder"
      className="bg-white"
      data-testid="founder-section"
    >
      <div className="container-kw section">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div
                className="absolute inset-0 rounded-3xl -rotate-2"
                style={{ background: "var(--kw-yellow)" }}
                aria-hidden="true"
              />
              <div className="relative rounded-3xl overflow-hidden bg-[color:var(--kw-black)] aspect-[4/5] flex items-end p-8">
                <div className="text-white">
                  <div className="eyebrow text-white/60">Founder & CEO</div>
                  <div className="mt-3 font-display font-black text-4xl md:text-5xl tracking-tight">
                    Gurjant
                    <br />
                    Singh
                  </div>
                </div>
                <div className="absolute top-8 right-8 flex flex-col gap-3 text-white/80">
                  <PenTool className="h-6 w-6" />
                  <Feather className="h-6 w-6" />
                  <Heart className="h-6 w-6" />
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="eyebrow">The Person Behind</div>
            <h2 className="mt-5 font-display font-bold text-4xl md:text-5xl tracking-tight text-[color:var(--kw-black)]">
              Gurjant Singh
            </h2>
            <div className="mt-2 text-[color:var(--kw-muted)] text-sm md:text-base tracking-wide">
              Founder &amp; CEO — King&apos;s Wake Digital
            </div>
            <p className="mt-8 text-lg md:text-2xl leading-relaxed text-[color:var(--kw-black)] font-medium">
              A ballpoint pen artist, aspiring writer, and a principled
              idealist—driven by a vision to build meaningful platforms while
              advocating for compassion and a world free from animal suffering.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-lg">
              <div>
                <div className="font-display font-bold text-2xl">Art</div>
                <div className="text-xs uppercase tracking-widest text-[color:var(--kw-muted)] mt-1">
                  Ballpoint pen
                </div>
              </div>
              <div>
                <div className="font-display font-bold text-2xl">Writing</div>
                <div className="text-xs uppercase tracking-widest text-[color:var(--kw-muted)] mt-1">
                  Aspiring author
                </div>
              </div>
              <div>
                <div className="font-display font-bold text-2xl">
                  Compassion
                </div>
                <div className="text-xs uppercase tracking-widest text-[color:var(--kw-muted)] mt-1">
                  For all beings
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
